import "./CarteProfile.css";
import React from 'react';
import Button from 'react-bootstrap/Button';
import {Container,Row,Col} from 'react-bootstrap';
import Card from 'react-bootstrap/Card';


 import tof1 from '../../Assets/imge/istockphoto-1270067126-612x612.jpg';
 import tof2 from '../../Assets/imge/gettyimages-629077354-612x612.jpg';
 import tof3 from '../../Assets/imge/istockphoto-1289220545-612x612.jpg';


function template() {
  return (
    <div className="carte-profile">
     <Container>
     
      <Row>
       
        <Col  md={3}>
        <Card style={{ width: '' }}>
          <div class="dropdown">
  <button class="dropbtn"><span  className=" " style={{color:'black' }}>...</span></button>
  <div className="dropdown-content">
    
  <a href="/#" ><Button variant="danger">Supirmer</Button></a>
  <a href="/#"><Button variant="success">Modifier</Button></a>
  <a href="/#"><Button variant="secondary">Archiver</Button></a>
  <a href="/#"><Button variant="secondary">Prof</Button></a>



  </div>
</div>

      <Card.Img variant="top" src={tof1} class="imgi" alt='tof1' />
      <Card.Body>
        <Card.Title className="text-center">Nom:</Card.Title>
        <Card.Text>
          <h6 className="mt-5" >Nombre Etudiant:(45) </h6>
          <h6 className="font-size-1" >Nombre Coures: (24) </h6>

       </Card.Text>
      </Card.Body>
    </Card>
        </Col>

        <Col  md={3}>
          
          
        <Card style={{ width: '' }}>
        <div class="dropdown">
  <button class="dropbtn"><span  className=" " style={{color:'black' }}>...</span></button>
  <div className="dropdown-content">
    
  <a href="/#" ><Button variant="danger">Supirmer</Button></a>
  <a href="/#"><Button variant="success">Modifier</Button></a>
  <a href="/#"><Button variant="secondary">Archiver</Button></a>
  <a href="/#"><Button variant="secondary">Prof</Button></a>


  </div>
</div>
        <Card.Img variant="top" src={tof2} class="imgi " alt='tof1' />

      <Card.Body>
      <Card.Title className="text-center">Nom:</Card.Title>
      <Card.Text>
          <h6 className="mt-5">Nombre Etudiant: (25) </h6>
          <h6 >Nombre Coures:(25) </h6>

       </Card.Text>
      </Card.Body>
    </Card>
        </Col>
        <Col md={3}>
        <Card style={{ width: '' }}>
        <div class="dropdown">
  <button class="dropbtn"><span  className=" " style={{color:'black' }}>...</span></button>
  <div className="dropdown-content">
  <a href="/#" ><Button variant="danger">Supirmer</Button></a>
  <a href="/#"><Button variant="success">Modifier</Button></a>
  <a href="/#"><Button variant="secondary">Archiver</Button></a>
  <a href="/#"><Button variant="secondary">Prof</Button></a>



  </div>
</div>
        <Card.Img variant="top" src={tof3} class="imgi " alt='tof1' />

      <Card.Body>
      <Card.Title className="text-center">Nom:</Card.Title>
         <Card.Text>
          <h6 className="mt-5">Nombre Etudiant: (18) </h6>
          <h6 >Nombre Coures:(15) </h6>

       </Card.Text>
      </Card.Body>
    </Card>
        </Col>
      </Row>
    </Container>
    
    </div>
  );
};

export default template;
